import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/app/environments/environment';

export const SERVER_API_URL = environment.serverUrl;

const routes = {
  po: {
    createPurchaseOrder: () => `${SERVER_API_URL}/api/v1/createPurchaseOrder/:company_id`,
    createPOFromPR: () => `${SERVER_API_URL}/api/v1/createPOFromPR`,
    getPoList: (empId: any,company_id:any) => `${SERVER_API_URL}/api/v1/getPurchaseOrders/${company_id}/${empId}`,
    getAllPurchaseorderDetails: () =>
      `${SERVER_API_URL}/api/v1/getAllPurchaseorderDetails`,
    getPendingPoList: (emp_id: any, status: any, companyId: any) =>
      `${SERVER_API_URL}/api/v1/getPOByApprovalStatus/${status}/${emp_id}?companyId=${companyId}`,
    approvePoData: () => `${SERVER_API_URL}/api/v1/UpdatePoStatus`,
    rejectPoData: () => `${SERVER_API_URL}/api/v1/UpdatePoStatus`,
    getApprovedPO: (id: any,companyId: any) => `${SERVER_API_URL}/api/v1/getapprovedPO/${id}?companyId=${companyId}`,
    getRejectedPO: (id: any,companyId: any) => `${SERVER_API_URL}/api/v1/getRejectedPo/${id}?companyId=${companyId}`,
    getVendorList: (company_id:any) => `${SERVER_API_URL}/api/v1/getAllActiveVendor/${company_id}`,
    getAllBillingAdress: (company_id: any) =>
      `${SERVER_API_URL}/api/v1/getAllBillingAdress/${company_id}`,
    getAssetClassOrCategoriesByVendor: (id: any) =>
      `${SERVER_API_URL}/api/v1/getAssetClassOrCategoriesByVendor/${id}`,
    createAdvancePayment: () => `${SERVER_API_URL}/api/v1/createAdvancePayment`,
    getPoById: (id: any) => `${SERVER_API_URL}/api/v1/getPoById/${id}`,
    getassetCategoriesByAssetClass: (id: any) =>
      `${SERVER_API_URL}/api/v1/getassetCategoriesByAssetClass/${id}`,
    getLastCreatedPo: (emp_id: any) =>
      `${SERVER_API_URL}/api/v1/getLastCreatedPo/${emp_id}`,
    updatePoStatusForGrn: () => `${SERVER_API_URL}/api/v1/updatePoStatusForGrn`,

    checkPOInsight: () => `${SERVER_API_URL}/api/v1/checkPOInsight`,

    getAllPOMilestones: (companyId:any) => `${SERVER_API_URL}/api/v1/getAllPOMilestones/${companyId}`,

    getMilestonesByPoId: (companyId:any,poId: any) =>
      `${SERVER_API_URL}/api/v1/getMilestonesByPoId/${companyId}/${poId}`,

    createContractPO: () => `${SERVER_API_URL}/api/v1/createContractPO`,
    getAllPort: () =>
      `${SERVER_API_URL}/api/v1/getAllPort`,
    getAllIncoterm: () =>
      `${SERVER_API_URL}/api/v1/getAllIncoterm`,
    duplicatePo: () => `${SERVER_API_URL}/api/v1/duplicatePo`,
    getAllDraftPOs: (company_id: any, empId: any) => `${SERVER_API_URL}/api/v1/getAllDraftPOs/${company_id}/${empId}`,
    submitDraftPO: () => `${SERVER_API_URL}/api/v1/submitDraftPO`,
    deleteDraftPO: (po_id: any) => `${SERVER_API_URL}/api/v1/deleteDraftPO/${po_id}`,
    updateDraftPO: () => `${SERVER_API_URL}/api/v1/updateDraftPO`,
    getPoDetails: (po_id: any) => `${SERVER_API_URL}/api/v1/getPoDetails/${po_id}`,
  },
};

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderService {
  constructor(private http: HttpClient) { }

  createPurchaseOrder(data: any): Observable<any> {
    return this.http.post<any>(
      routes.po.createPurchaseOrder(),
      { data },
      { observe: 'response' },
    );
  }

  createPOFromPR(data: any): Observable<any> {
    return this.http.post<any>(
      routes.po.createPOFromPR(),
      { data },
      { observe: 'response' },
    );
  }
  createAdvancePayment(data: any): Observable<any> {
    return this.http.post<any>(
      routes.po.createAdvancePayment(),
      { data },
      { observe: 'response' },
    );
  }

  getPOLIstById(id: any, company_id: any): Observable<any> {
    return this.http.get<any>(routes.po.getPoList(id,company_id), { observe: 'response' });
  }
  getAllPurchaseorderDetails(data: any): Observable<any> {
    return this.http.post<any>(routes.po.getAllPurchaseorderDetails(), data, {
      observe: 'response',
    });
  }
  getPendingPoList(id: any, status: any,companyId: any ): Observable<any> {
    return this.http.get<any>(routes.po.getPendingPoList(status,id, companyId), {
      observe: 'response',
    });
  }
  getAllBillingAdress(company_id: any): Observable<any> {
    return this.http.get<any>(routes.po.getAllBillingAdress(company_id), {
      observe: 'response',
    });
  }
  approvePoData(data: any): Observable<any> {
    return this.http.post<any>(routes.po.approvePoData(), data, {
      observe: 'response',
    });
  }
  rejectPoData(data: any): Observable<any> {
    return this.http.post<any>(routes.po.rejectPoData(), data, {
      observe: 'response',
    });
  }
  getApprovedPo(id: any,companyId: any): Observable<any> {
    return this.http.get<any>(routes.po.getApprovedPO(id,companyId), {
      observe: 'response',
    });
  }
  getRejectedPo(id: any,companyId: any): Observable<any> {
    return this.http.get<any>(routes.po.getRejectedPO(id,companyId), {
      observe: 'response',
    });
  }
  getVendorList(company_id: any): Observable<any> {
    return this.http.get<any>(routes.po.getVendorList(company_id), {
      observe: 'response',
    });
  }
  getAssetClassOrCategoriesByVendor(id: any): Observable<any> {
    return this.http.get<any>(routes.po.getAssetClassOrCategoriesByVendor(id), {
      observe: 'response',
    });
  }
  getAssetCategoryByAssestClass(id: any): Observable<any> {
    return this.http.get<any>(routes.po.getassetCategoriesByAssetClass(id), {
      observe: 'response',
    });
  }
  getPoById(id: any): Observable<any> {
    return this.http.get<any>(routes.po.getPoById(id), { observe: 'response' });
  }
  getLastCreatedPo(emp_id: any): Observable<any> {
    return this.http.get<any>(routes.po.getLastCreatedPo(emp_id), {
      observe: 'response',
    });
  }
  updatePoStatusForGrn(payload: any): Observable<any> {
    return this.http.put<any>(routes.po.updatePoStatusForGrn(), payload, {
      observe: 'response',
    });
  }

  getAllPOMilestones( companyId: any,page: number, limit: number, searchText: string) {
    let url =
      routes.po.getAllPOMilestones(companyId) + `?page=${page}` + `&limit=${limit}`;

    // ADD SEARCH PARAM
    if (searchText && searchText.trim() !== '') {
      url += `&search=${searchText}`;
    }
    return this.http.get<any>(url);
  }

  getMilestonesByPOCode(companyId: number,poId: number): Observable<any> {
    return this.http.get<any>(routes.po.getMilestonesByPoId(companyId,poId));
  }

  checkPOInsight(payload: any): Observable<any> {
    return this.http.post<any>(routes.po.checkPOInsight(), payload, {
      observe: 'response',
    });
  }

  createContractPO(data: any): Observable<any> {
    return this.http.post<any>(routes.po.createContractPO(), data, { observe: 'response' });
  }

  getAllPort(company_id: any): Observable<any> {
    return this.http.get<any>(routes.po.getAllPort(), {
      observe: 'response',
      params: { company_id }
    });
  }

  getAllIncoterm(): Observable<any> {
    return this.http.get<any>(routes.po.getAllIncoterm(), { observe: 'response' });
  }

  getShippingAlerts(empId: any,company_id:any): Observable<any> {
    return this.getPOLIstById(empId,company_id).pipe(
      map((res: any) => {
        const poList = res?.body?.data || [];
        const carriers = ['DHL Express', 'FedEx', 'BlueDart', 'DTDC'];
        const alerts = poList
          .filter((po: any) => (po.asnCode || po.asn_code) && (po.asnCode || po.asn_code).toString().trim() !== '')
          .map((po: any, index: number) => {
            const delayDays = index % 3 === 0 ? 5 + (index % 5) : 0;
            const status = delayDays > 4 ? 'Custom Hold' : (delayDays > 0 ? 'Delayed' : 'In Transit');
            const severity = delayDays > 4 ? 'Critical' : (delayDays > 0 ? 'Warning' : 'On Track');
            return {
              asn_id: po.asn_id,
              asn_code: po.asnCode || po.asn_code,
              po_id: po.po_id,
              poCode: po.poCode,
              vendorName: po.supplierName || 'Nexus Industrial Tech',
              vendorContactNo: po.contactNo || '9123456789',
              carrier: po.carrier || carriers[index % carriers.length],
              trackingNo: 'TRK' + (9876543210 - index),
              shipDate: po.shipDate,
              eta: po.eta || new Date(new Date(po.createdAt).getTime() + (delayDays + 3) * 24 * 60 * 60 * 1000).toISOString(),
              daysDelayed: delayDays,
              stage: po.stage,
              status: po.stage,
              severity: severity,
              description: `Shipment delayed due to ${status === 'Custom Hold' ? 'customs document clearance' : 'weather delay at transit hub'}.`,

              transportMode: po.transportMode,
              driverMobile: po.driverMobile,
              transporterName: po.transporterName,
              lrNo: po.lrNo,
              vehicleno: po.vehicleno,
              drivername: po.drivername,
              trainNumber: po.trainNumber,
              trainName: po.trainName,
              railwayZone: po.railwayZone,
              wagonNumber: po.wagonNumber,
              rrNumber: po.rrNumber,
              rrDate: po.rrDate,
              coachNumber: po.coachNumber,
              containerNumber: po.containerNumber,
              vesselName: po.vesselName,
              voyageNumber: po.voyageNumber,
              shippingLine: po.shippingLine,
              containerType: po.containerType,
              sealNumber: po.sealNumber,
              blNumber: po.blNumber,
              blDate: po.blDate,
              airlineName: po.airlineName,
              flightNumber: po.flightNumber,
              awbNumber: po.awbNumber,
              awbDate: po.awbDate,
              invoiceAmount: po.invoiceAmount,
              shippmentApproval: po.shippmentApproval,
              totalAmount: po.priceIncludingCharges || 12000,
              subject: po.summary || 'Godrej Fridge',
              vendor_type: po.vendor_type,
              forwarderFreightCharges: po.forwarderFreightCharges,
              loadingUnloadingCharges: po.loadingUnloadingCharges,
              portToWarehouseCharges: po.portToWarehouseCharges,

              // BOE & CHA fields from DB
              boeNumber: po.boeNumber,
              boeDate: po.boeDate,
              exchangeRate: po.exchangeRate,
              frieghtCharges: po.frieghtCharges,
              insuranceCharges: po.insuranceCharges,
              assesesableValue: po.assesesableValue,
              importDuty: po.importDuty,
              dutyAmount: po.dutyAmount,
              chaServiceCharges: po.chaServiceCharges,
              otherCharges: po.otherCharges,
              varianceRemark: po.varianceRemark,
              chaDocument: po.chaDocument,
              ApprovalRemarks: po.ApprovalRemarks
            };
          });

        if (alerts.length === 0) {
          return {
            body: {
              data: [
                {
                  asn_id: 5001,
                  po_id: 101,
                  poCode: 'PO-2026-0001',
                  asn_code: 'SA004',
                  vendorName: 'Acme Industrial Supplies',
                  carrier: 'DHL Express',
                  trackingNo: 'TRK770012345',
                  shipDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
                  eta: '23-06-2026',
                  daysDelayed: 6,
                  status: 'Pending',
                  severity: 'Critical',
                  description: 'Held at customs due to import duty validation. Commercial invoice update required.',

                  transportMode: 'ROAD',
                  driverMobile: '818100173',
                  transporterName: 'vinay Logistics',
                  lrNo: 'Up300290',
                  vehicleno: 'Up31u7190',
                  drivername: 'vinaytiwaro',
                  totalAmount: 12000,
                  subject: 'Godrej Fridge',
                  vendor_type: 'International',
                  freightForwarder: 'Apex Global Logistics'
                },
                {
                  asn_id: 5002,
                  po_id: 102,
                  poCode: 'PO-2026-0002',
                  asn_code: 'SA005',
                  vendorName: 'Nexus Tech Components',
                  carrier: 'FedEx',
                  trackingNo: 'TRK880192837',
                  shipDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
                  eta: '24-06-2026',
                  daysDelayed: 2,
                  status: 'Delayed',
                  severity: 'Warning',
                  description: 'Delayed in transit at Chicago Hub due to winter storm conditions.',

                  transportMode: 'ROAD',
                  driverMobile: '818100174',
                  transporterName: 'Nexus Logistics',
                  lrNo: 'Up300291',
                  vehicleno: 'Up31u7191',
                  drivername: 'rahulsharma',
                  totalAmount: 15000,
                  subject: 'Induction Cooker',
                  vendor_type: 'International',
                  freightForwarder: 'DHL Forwarding'
                },
                {
                  asn_id: 5003,
                  po_id: 103,
                  poCode: 'PO-2026-0003',
                  asn_code: 'SA006',
                  vendorName: 'Apex Machinery Ltd',
                  carrier: 'BlueDart',
                  trackingNo: 'TRK992817362',
                  shipDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
                  eta: '25-06-2026',
                  daysDelayed: 0,
                  status: 'In Transit',
                  severity: 'On Track',
                  description: 'Departed sorting facility and heading to final delivery station.',

                  transportMode: 'ROAD',
                  driverMobile: '818100175',
                  transporterName: 'Apex Logistics',
                  lrNo: 'Up300292',
                  vehicleno: 'Up31u7192',
                  drivername: 'amitverma',
                  totalAmount: 22000,
                  subject: 'Washing Machine',
                  vendor_type: 'Domestic',
                  freightForwarder: 'BlueDart Domestic'
                },
                {
                  asn_id: 5004,
                  po_id: 104,
                  poCode: 'PO-2026-0004',
                  asn_code: 'SA007',
                  vendorName: 'Global Micro Components Inc.',
                  vendorContactNo: '18005550199',
                  carrier: 'FedEx',
                  trackingNo: 'TRK992817365',
                  shipDate: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
                  eta: '26-06-2026',
                  daysDelayed: 0,
                  status: 'Arrived',
                  severity: 'On Track',
                  description: 'Shipment has arrived at destination port/airport.',
                  transportMode: 'AIR',
                  driverMobile: '9988776655',
                  transporterName: 'FedEx Cargo',
                  lrNo: 'LR-998877',
                  vehicleno: 'MH-12-PQ-9876',
                  drivername: 'John Doe',
                  totalAmount: 45000,
                  subject: 'Microchips & Sensors',
                  vendor_type: 'International',
                  freightForwarder: 'Apex Global Logistics'
                }
              ]
            }
          };
        }
        return { body: { data: alerts } };
      })
    );
  }

  getShipmentTimeline(poCode: string, currentStage: string = 'In Transit'): Observable<any> {
    const stages = ['In Transit', 'Arrived', 'Clearance', 'Boe Approved', 'Item Claims', 'Cha Bill Generated', 'Out For Delivery', 'Received'];

    let stageCheck = (currentStage || '').toLowerCase();
    if (stageCheck === 'gate entry' || stageCheck === 'received' || stageCheck === 'recieved') {
      stageCheck = 'received';
    }

    let currentIndex = stages.findIndex(s => s.toLowerCase() === stageCheck);

    if (currentIndex === -1) {
      if ((currentStage || '').toLowerCase() === 'delayed') {
        currentIndex = 0;
      } else if ((currentStage || '').toLowerCase() === 'custom hold') {
        currentIndex = 1;
      } else {
        currentIndex = 0;
      }
    }

    const timeline = stages.map((stageName, index) => {
      const isCompleted = index < currentIndex;
      const isCurrent = index === currentIndex;

      let statusClass = 'pending';
      let dateStr = 'Pending';

      if (index <= currentIndex) {
        statusClass = isCompleted ? 'completed' : 'active';

        // Generate simulated dates matching format: DD-MM-YYYY 05:17 PM
        const dateObj = new Date(Date.now() - (currentIndex - index) * 24 * 60 * 60 * 1000);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        dateStr = `${day}-${month}-${year} 05:17 PM`;
      }

      return {
        title: stageName,
        description: index <= currentIndex ? `By ${poCode}` : 'Pending',
        date: dateStr,
        status: statusClass
      };
    });

    return of({ body: { data: timeline } });
  }

  getItemsByPoIdForShipment(poId: any): Observable<any> {
    return this.http.get<any>(`${SERVER_API_URL}/api/v1/getitemsByPoIdForShipment/${poId}`, { observe: 'response' });
  }

  approveShipping(payload: any): Observable<any> {
    return this.http.patch<any>(`${SERVER_API_URL}/api/v1/approveShipping`, payload, { observe: 'response' });
  }

  getAsnById(id: any): Observable<any> {
    return this.http.get<any>(`${SERVER_API_URL}/api/v1/getAsnById/${id}`, { observe: 'response' });
  }

  getAsnDetails(id: any): Observable<any> {
    return this.http.get<any>(`${SERVER_API_URL}/api/v1/getAsnDetails/${id}`, { observe: 'response' });
  }

  sendChaEmail(payload: any): Observable<any> {
    return this.http.post<any>(`${SERVER_API_URL}/api/v1/sendChaEmail`, payload, { observe: 'response' });
  }

  updateStageShippment(payload: any): Observable<any> {
    return this.http.patch<any>(`${SERVER_API_URL}/api/v1/updateStageShippment`, payload, { observe: 'response' });
  }

  duplicatePo(data: any): Observable<any> {
    return this.http.post<any>(routes.po.duplicatePo(), data, { observe: 'response' });
  }

  getAllDraftPOs(company_id: any, empId: any): Observable<any> {
    return this.http.get<any>(routes.po.getAllDraftPOs(company_id, empId), { observe: 'response' });
  }

  submitDraftPO(data: any): Observable<any> {
    return this.http.post<any>(routes.po.submitDraftPO(), data, { observe: 'response' });
  }

  deleteDraftPO(po_id: any): Observable<any> {
    return this.http.delete<any>(routes.po.deleteDraftPO(po_id), { observe: 'response' });
  }

  updateDraftPO(data: any): Observable<any> {
    return this.http.put<any>(routes.po.updateDraftPO(), { data }, { observe: 'response' });
  }

  getPoDetails(po_id: any): Observable<any> {
    return this.http.get<any>(routes.po.getPoDetails(po_id), { observe: 'response' });
  }
}

